import React, { Component } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import axios from "axios";

import HorizontalArrow from "./horizontalArrow";

class HorizontalSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      overlay: false
    };

    this.performSearch = this.performSearch.bind(this);
  }

  componentDidMount() {
    this.performSearch();
  }

  triggerResize() {
    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
      var evt = document.createEvent("UIEvents");
      evt.initUIEvent("resize", true, false, window, 0);
      window.dispatchEvent(evt);
    } else {
      window.dispatchEvent(new Event("resize"));
    }
  }

  performSearch() {
    var instance = this;

    axios
      .get(this.props.api.slickslidesH)
      .then(results => {
        const data = results.data.CarouselList;
        this.setState(
          {
            data: data,
            overlay: results.data.EnableOverlay
          },
          function () {
            instance.triggerResize();
          }
        );
      })
      .catch(err => {
        throw err;
      });
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      centerMode: false,
      className: this.state.data.length <= 1 ? "full-width-header" : "",
      beforeChange: (current, next) => {
        if (this.state.data.length === 0) {
          return;
        }

        var item = "banner slide";

        if (window.event == null) {
          item = current > next ? "banner left arrow" : "banner right arrow";
        } else {
          var target = window.event.target;
          if (target != null && target.nodeName != null) {
            if (target.nodeName.toLowerCase() === "button") {
              item = "banner button circle";
            } else if (target.nodeName.toLowerCase() === "path" && target.parentElement?.parentElement != null) {
              if (target.parentElement.parentElement.classList.contains("rightArrow")) {
                item = "banner right arrow";
              } else {
                item = "banner left arrow";
              }
            } else if (target.nodeName.toLowerCase() === "svg" && target.parentElement != null) {
              if (target.parentElement.classList.contains("rightArrow")) {
                item = "banner right arrow";
              } else {
                item = "banner left arrow";
              }
            }
          }
        }

        methodist.analytics.pushEvent("interface_interactions", {
          component: {
            interaction_item: item,
            sc_component_name: "Hero Carousel Banner",
            sc_component_position: next + 1,
            sc_component_title: this.state.data[next].Title
          }
        });
      },
      appendDots: dots => (
        <div>
          <HorizontalArrow direction="prev" onClick={() => this.reference.slickPrev()} />
          <ul>{dots}</ul>
          <HorizontalArrow direction="next" onClick={() => this.reference.slickNext()} />
        </div>
      )
    };

    return (
      <div className={this.state.overlay ? "overlay" : "nooverlay"}>
        <Slider ref={reference => (this.reference = reference)} {...settings}>
          {this.state.data.map(slide => (
            <div key={slide.ItemID}>
              <a href={slide.PageUrl}>
                <img src={slide.ImageURL}></img>
              </a>
              <div className="slide-bottom">
                <a className="slide-bottom__inner" href={slide.PageUrl}>
                  {slide.Title && <h2>{slide.Title}</h2>}
                  {slide.Title && <i className="fa fa-angle-double-right" aria-hidden="true"></i>}
                  {slide.SubTitle && <h3>{slide.SubTitle}</h3>}
                  {slide.Teaser && <div className="teaser">{slide.Teaser}</div>}
                </a>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}

HorizontalSlider.propTypes = {
  api: PropTypes.object
};

export default HorizontalSlider;
